// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import EditButton from '../../../common/iconButtons/EditButton'
import type { Station } from '../../station/stationTypes'
import css from './stationTable.css'

type StationRowProps = {
  data: Station
  match: any
}

const StationRow = ({ data, match }: StationRowProps) => (
  <TableRow>
    <TableCell className={css.tableCell}>{data.name}</TableCell>
    <TableCell className={css.actionsCell} align='right'>
      <Link to={`${match.path}perustiedot/${data.id}`}>
        <EditButton />
      </Link>
    </TableCell>
  </TableRow>
)

export default withRouter(StationRow)
